<template>
  <div v-if="prompt" class="details">
    <div class="detailRow">
      <span class="detailLabel">PROMPT</span>
      <span class="detailValue">{{ truncatedPrompt }}</span>
    </div>
    <div v-if="numResults" class="detailRow">
      <span class="detailLabel">RESULTS</span>
      <span class="detailValue">{{ numResults }} per run</span>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

const props = defineProps<{
  config: Record<string, any>
}>()

const prompt = computed(() => (props.config.prompt || '').trim())
const numResults = computed(() => props.config.num_results || 25)

const truncatedPrompt = computed(() => {
  const p = prompt.value
  if (p.length <= 120) return p
  return p.slice(0, 117) + '...'
})
</script>

<style scoped>
.details {
  display: flex;
  flex-direction: column;
  gap: var(--space-1);
}
.detailRow {
  display: flex;
  align-items: baseline;
  gap: var(--space-3);
}
.detailLabel {
  font-family: var(--font-sans);
  font-size: var(--fs-xs);
  font-weight: var(--fw-semibold);
  letter-spacing: var(--tracking-wide);
  color: var(--color-text-tertiary);
  flex-shrink: 0;
  min-width: 70px;
}
.detailValue {
  font-family: var(--font-sans);
  font-size: var(--fs-sm);
  color: var(--color-text-secondary);
}
</style>
